import produce from 'immer';

const INITIAL_STATE = {
    loading: false,
    data: [],
    page: 1,
    pageSize: 99999,
    totalCount: 0,
    totalPages: 0,
    find: null,
    params: {},
};

export default function rateio(state = INITIAL_STATE, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case '@rateio/FIND_DATA':
            case '@rateio/UPDATE_DATA':
            case '@rateio/DELETE_DATA':
            case '@rateio/DATA_IN_REQUEST':
            case '@rateio/STORE_DATA': {
                draft.loading = true;
                break;
            }

            case '@rateio/SUCCESS_REMOVE':
            case '@rateio/FAILED_REQUEST': {
                draft.loading = false;
                break;
            }

            case '@rateio/STOP_LOADING': {
                draft.loading = false;
            }

            case '@rateio/SUCCESS_IN_REQUEST': {
                draft.loading = false;
                draft.data = action.payload.data;
                draft.page = action.payload.page;
                draft.pageSize = action.payload.pageSize;
                draft.totalCount = action.payload.totalCount;
                draft.totalPages = action.payload.totalPages;
                draft.find = {};
                break;
            }

            case '@rateio/SUCCESS_REQUEST': {
                draft.loading = false;
                draft.find = action.payload.data;
                break;
            }

            case '@rateio/RECORD_FILTERING': {
                draft.loading = true;
                //draft.params = { ...draft.params, ...action.payload.params };
                draft.params = action.payload.params;
                break;
            }

            case '@hooks/RESET': {
                draft.data = [];
                draft.page = 1;
                draft.pageSize = 10;
                draft.totalCount = 0;
                draft.totalPages = 0;
                draft.find = null;
                draft.params = {};
                break;
            }

            default:
        }
    });
}
